// @flow
import React from "react";
import { GlobalProvider } from "../common/GlobalContext";
import DMCABody from "./DMCABody";

type $Props = {
  theme: Object,
};

const DMCA = ({ theme }: $Props) => (
  <GlobalProvider theme={theme}>
    <DMCABody />
  </GlobalProvider>
);

export default DMCA;
